import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

const getToken = () => localStorage.getItem("token") || "";
let isRefreshing = false;
let failedRequestsQueue = [];

const refreshAccessToken = async () => {
  if (isRefreshing) {
    return new Promise((resolve) => {
      failedRequestsQueue.push((newToken) => resolve(newToken));
    });
  }

  isRefreshing = true;

  try {
    delete axiosInstance.defaults.headers.common["Authorization"];
    const response = await axiosInstance.post("/auth/refresh-token");
    const { token } = response.data;

    localStorage.setItem("token", token);
    axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    failedRequestsQueue.forEach((callback) => callback(token));
    failedRequestsQueue = [];

    return token;
  } catch (error) {
    localStorage.removeItem("token");
    failedRequestsQueue = [];
    throw error;
  } finally {
    isRefreshing = false;
  }
};

axiosInstance.interceptors.request.use(
  (config) => {
    if (!config.url.includes("/auth/refresh-token")) {
      const token = getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url.includes("/auth/refresh-token")
    ) {
      originalRequest._retry = true;

      try {
        const newToken = await refreshAccessToken();
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        localStorage.removeItem("token");
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
